import { Link } from "react-router-dom";
import KtrlLayout from "../../components/ktrl/KtrlLayout";

const sections = [
  {
    title: "Harness-arkitektur: Rammer fremfor kaos",
    text: 'Vi bygget ikke en tradisjonell chatbot. Vi bruker en "harness" – en robust ramme rundt eksisterende AI-modeller som Gemini og Claude. I stedet for å la en modell hallusinere fritt, setter vi den i en definert rolle hvor den oppfører seg konsistent og kontrollert innenfor sitt domene. Tenk på det som å ansette en erfaren, disiplinert medarbeider med stramme retningslinjer, heller enn en vilkårlig AI som kan finne på å si hva som helst.',
  },
  {
    title: "HITL: Mennesket i loopen",
    text: "Klaw eskalerer alltid til et menneske ved komplekse saker eller når agenten selv er usikker på svaret (Human-In-The-Loop). Ingen kunder skal noen gang oppleve å bli stående fast uten et reelt svar, og ingen AI-agent skal presses utover sin egen kompetanse. Resultatet? Dramatisk lavere frustrasjon og langt høyere tillit fra kundene.",
  },
  {
    title: "Rask onboarding med RAG",
    text: "I stedet for å kaste bort måneder på trening og finjustering av egne modeller, bruker Klaw RAG (Retrieval Augmented Generation). Agenten kobles direkte på selskapets eksisterende FAQ og kunnskapsbase. Dette betyr at en ny klient kan ha en operativ agent klar på timer, ikke uker. Den svarer basert på selskapets egne, faktiske data.",
  },
  {
    title: "Sikkerhet og streng scope-begrensning",
    text: "Agenten svarer utelukkende på det den er satt opp til å svare på. Forsøk på prompt injection, off-topic-spørsmål eller urimelige refusjonskrav håndteres og avvises automatisk. Det er bedriften – ikke AI-modellen – som bestemmer nøyaktig hva agenten kan og ikke kan gjøre.",
  },
  {
    title: "I praksis: Møt Aurora Iversen for Naardic",
    text: '"Aurora Iversen" håndterer daglig supporthenvendelser effektivt via både chat og e-post for Naardic, en norsk fitness-plattform, og avlaster kundeservice-teamet slik at de kan fokusere på de virkelig krevende sakene.',
  },
];

const KtrlBlogPostFilosofi = () => {
  return (
    <KtrlLayout>
      <article className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <Link to="/blogg" className="text-sm text-indigo-600 hover:underline">
          ← Tilbake til bloggen
        </Link>
        <div className="text-sm text-slate-500 mt-6 mb-2">27. mars 2026 · Produktfilosofi</div>
        <h1 className="text-2xl md:text-4xl font-bold tracking-tight text-slate-900 mb-4">
          Hvorfor vi bygget Klaw KTRL slik vi bygget det
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed mb-12">
          De fleste AI-chatboter frustrer kundene. Vi ville bygge noe annerledes.
        </p>

        <div className="flex flex-col gap-10">
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className="text-xl font-bold text-slate-900 mb-3">{s.title}</h2>
              <p className="text-slate-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </article>
    </KtrlLayout>
  );
};

export default KtrlBlogPostFilosofi;
